module.exports = __webpack_public_path__ + "assets/img/17.30f2497d.png";